import { Label } from "@/components/ui/shadcn/Label/Label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/shadcn/Select/Select";
import { formatLocalOrIntlPhoneNumber } from "@/lib/utils/format";

export function ContactPhoneNumberField({
  phones,
  value,
  onChange,
}: {
  phones: { id: string; label: string; number: string }[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="space-y-2">
      <Label>Contact number</Label>
      {phones.length ? (
        <Select
          value={value || "none"}
          onValueChange={(nextValue) => {
            onChange(nextValue === "none" ? "" : nextValue);
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="No number recorded" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">No number recorded</SelectItem>
            {phones.map((phone) => (
              <SelectItem key={phone.id} value={phone.number}>
                {formatLocalOrIntlPhoneNumber(phone.number)}
                {phone.label ? ` (${phone.label})` : ""}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <p className="text-muted-foreground rounded-md border px-3 py-2 text-sm">
          This contact has no saved phone number.
        </p>
      )}
    </div>
  );
}
